import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'
import type { FindingResolutionState } from 'api/graphQL/types/specIntelligence.types'
import React from 'react'
import { formatLocalDateTime } from 'shared/utils/dateUtils'
import { STATE_COLORS, STATE_ICONS } from '../../specIntelligenceConstants'

/** Format used for the "on {date} at {time}" suffix of a resolved/dismissed state badge. */
const RESOLUTION_DATE_FORMAT = 'MMM DD, yyyy [at] hh:mm A'

const useStyles = makeStyles(() => ({
    stateBadge: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: pxToRem(3),
        flexShrink: 1,
        maxWidth: '100%',
        minHeight: pxToRem(18),
        borderRadius: pxToRem(4),
        padding: `${pxToRem(3)} ${pxToRem(6)}`,
        fontSize: pxToRem(10),
        fontWeight: 500,
        lineHeight: 1.4,
    },
    stateBadgeIcon: { fontSize: pxToRem(12), display: 'block', flexShrink: 0, marginTop: pxToRem(1) },
    stateBadgeLabel: { display: 'inline-block', whiteSpace: 'normal', wordBreak: 'break-word' },
    stateBadgeName: { fontWeight: 800 },
}))

export interface StateBadgeProps {
    state: FindingResolutionState
    resolvedByName: string | null
    resolvedAt: string | null
}

/** Badge showing a finding's resolution state (Open/Resolved/Dismissed), with who and when for resolved/dismissed findings. */
const StateBadge = ({ state, resolvedByName, resolvedAt }: StateBadgeProps) => {
    const classes = useStyles()
    const StateIcon = STATE_ICONS[state]
    const label =
        resolvedByName && resolvedAt ? (
            <>
                {state} by <span className={classes.stateBadgeName}>{resolvedByName}</span> on{' '}
                {formatLocalDateTime(new Date(resolvedAt), RESOLUTION_DATE_FORMAT)}
            </>
        ) : (
            state
        )
    return (
        <span className={classes.stateBadge} style={STATE_COLORS[state]}>
            <StateIcon className={classes.stateBadgeIcon} />
            <span className={classes.stateBadgeLabel}>{label}</span>
        </span>
    )
}

export default StateBadge
